export function formatIndianPrice(number) {
  const absNum = Math.abs(Number(number));
  
  if (absNum >= 10000000) {
    return (number / 10000000).toFixed(2) + ' Cr';
  } else if (absNum >= 100000) {
    return (number / 100000).toFixed(2) + ' Lakh';
  } else if (absNum >= 1000) {
    return (number / 1000).toFixed(2) + ' K';
  } else {
    return number.toString();
  }
}